export const isStaff = (currentUser: { email: string }) => {
  return (
    currentUser.email.endsWith("@upsmith.com") ||
    currentUser.email.endsWith("@athena.com")
  );
};
